
import Vue from 'vue';
import { postKcasEnrollmentVerifyTokenData } from '@kasasa/kloans-common-ui/dist/consumer-app/services/kloans-authentication';
import { Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import LoginStore from '@/login/store';
import { store } from '@/store';

getModule(LoginStore, store);

@Component
export default class EmailChangeVerification extends Vue {
	@Prop({ required: true })
	token!: string;

	@Prop({ default: '' })
	failureRoute!: string;

	appUrl = '/profile/#/confirm/email';

	async mounted() {
		try {
			const response = await postKcasEnrollmentVerifyTokenData(this.token);

			localStorage.setItem('CHANGE_EMAIL_TOKEN', JSON.stringify(response.data));
			setTimeout(() => {
				window.location.href = this.appUrl;
			}, 5000);
		} catch (error) {
			this.$router.push({ name: this.failureRoute });
		}
	}
}
